export default {
    baseUrl: {
        dev: 'https://api.jsgtkj.com',
        pro: 'https://api.jsgtkj.com'
    },
}



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 